import React from 'react'

import ServiceLocator from 'live/services/service-locator'
import widgetsService from 'live/services/widgets'
import clickHandlerService from '../click-handler-service'

import i18n from 'live/services/i18n'
import thumbnail from '../../assets/img/grid.png'

import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import { Grid, GridWithAlarms } from './widget/Widget'
import { gridReducer, gridPipelessReducer } from './widget/reducer'

import { addNewEditor } from '../editor/editorRegister'
import { Fields } from '../editor'
import GroupsField from '../editor/fields/groups/GroupsEditorField'

const type = 'Grid'
const typePipeless = 'GridPipeless'

// ServiceLocator (GridWithAlarms implementation)

ServiceLocator.registerService('plugin-grid-widget:click-handler', () => clickHandlerService)

ServiceLocator.getService('plugin-channel-alarms:channel-alarms').then(service => {
    widgetsService.impl(
        type,
        reactWidgetWrapper<GridReducerState, unknown, GridConfig>(
            props => GridWithAlarms({ ...props, ...service }),
            gridReducer
        )
    )
    widgetsService.impl(
        typePipeless,
        reactWidgetWrapper<GridReducerState, unknown, GridConfig>(
            props => GridWithAlarms({ ...props, ...service }),
            gridPipelessReducer
        )
    )
})

// Grid Register Configs

widgetsService.register({
    type: type,
    get name() {
        return i18n('Grid')
    },
    get description() {
        return i18n('Values grouped by grid.')
    },
    config: {},
    policies: { defaultReducer: '@latest' },
    properties: { color: true },
    impl: reactWidgetWrapper<GridReducerState, unknown, GridConfig>(Grid, gridReducer)
})

// GridPipeless Register Configs

widgetsService.register({
    type: typePipeless,
    get name() {
        return i18n('Grid')
    },
    get description() {
        return i18n('Add groups and select channels to create a custom visualization')
    },
    config: {
        groups: [],
        tableMode: false,
        tableModeConfig: { columns: 0, rows: 0, enable: false, showUOM: true, useChannelColor: true }
    },
    policies: { defaultReducer: '@latest' },
    properties: { color: true },
    queryHandlerKind: typePipeless,
    impl: reactWidgetWrapper<GridReducerState, unknown, GridConfig>(Grid, gridPipelessReducer)
})

addNewEditor(
    {
        type: typePipeless,
        order: 0,
        label: i18n('Grid'),
        description: i18n('Add groups and select channels to create a custom visualization'),
        thumbnail: thumbnail
    },
    [
        <Fields name="channels" key={'Fields 1'}>
            <GroupsField configField={'groups'} />
        </Fields>
    ]
)
